import { render, staticRenderFns } from "./MainReportsTags.vue?vue&type=template&id=7abba9d2&"
import script from "./MainReportsTags.vue?vue&type=script&lang=ts&"
export * from "./MainReportsTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports